export const TOASTER_ADD = 'TOASTER_ADD';
export const TOASTER_UPDATE = 'TOASTER_UPDATE';
export const TOASTER_REMOVE = 'TOASTER_REMOVE';
